// Module
var code = " <gh-lead-board-column *ngFor=\"let stage of stages\" [stage]=\"stage\" [priority]=\"priority\" [dropActive]=\"getZoneId(priority.id, stage.id) === (form.activeZoneId$ | async)\" class=\"m-column\"> </gh-lead-board-column> ";
// Exports
module.exports = code;